/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-25 16:53:55
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-12 17:22:57
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorMaintenancePage/Config/index.tsx
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LinkImgDraggableDisplay from '@/src/components/LinkImgDraggableDisplay';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { LinkModuleType } from '@/src/types/common/linkType';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { validateMaintenanceLongCanvas } from 'src/pages/SalesCannelVersion/SalesChannelEditorMaintenancePage/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getLongCanvas,
  getSubmitStamp,
  getUuid,
  onAddCanvas,
  onCollapseOpen,
  onErrorChange,
  onLongCanvasChange,
  onLongCanvasDelete,
  onLongCanvasMove,
} from '../slice';
import styles from './style.module.less';
import { permissions } from 'src/pages/SalesCannelVersion/SalesChannelEditorMaintenancePage/tools';

function Config(props) {
  const { specificError, isConvertible, saleChannelUuid } = props;
  const { edit_maintenance_page } = permissions(saleChannelUuid);

  const dispatch = useDispatch();
  const uuid = useSelector(getUuid());
  const longCanvas = useSelector(getLongCanvas());

  const handleItemAdd = () => {
    dispatch(onAddCanvas());
  };

  const handleItemChange = (index: number, data) => {
    dispatch(onLongCanvasChange({ index, data }));
  };

  const handleItemSort = (newIndex: number, oldIndex: number) => {
    dispatch(onLongCanvasMove({ newIndex, oldIndex }));
  };

  const handleItemDelete = (index: number) => {
    dispatch(onLongCanvasDelete(index));
  };

  return (
    <React.Fragment>
      <Section bottomBorder className={styles.tipContainer}>
        <span className={styles.tip}>
          You can add multiple images in this module.
        </span>
      </Section>
      <LinkImgDraggableDisplay
        disableDrag={isConvertible || !edit_maintenance_page}
        disabled={!edit_maintenance_page}
        //disabled={isConvertible}
        showImageDisplaySetting={isConvertible}
        error={specificError}
        hideAdd={isConvertible || !edit_maintenance_page}
        linkSet={{
          scopeVariables: { SalesChannel: props.saleChannelUuid },
          linkTypeFilter: [LinkModuleType.None, LinkModuleType.LinkLibrary],
        }}
        droppableId={uuid || 'maintenance'}
        data={longCanvas}
        {...(!isConvertible
          ? { addText: '+ Add Image & Link', onAdd: handleItemAdd }
          : {})}
        // addText='+ Add Image & Link'
        // onAdd={handleItemAdd}
        onChange={handleItemChange}
        onSort={handleItemSort}
        onDelete={handleItemDelete}
      />
    </React.Fragment>
  );
}
export default ErrorProcessingHOC(Config, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.longCanvas,
  getContent: getLongCanvas,
  title: 'Long Canvas',
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: (x, validationProps) => {
    const { isPrimary } = validationProps || {};

    return validateMaintenanceLongCanvas(x, !isPrimary);
  },
  getSubmitStamp,
});
